//
// Product view for slings
//
import scrollTo from '../../components/scrollTo/scrollTo'
import CartManager from '../../cart/cart-manager'
import { initVariantsTableSearch, initVariantsTableToggle } from '../../filter-common/filterExtended'
import axios from 'axios'
import { getFreshPrice, getDiscountProductPrice, getCartWidget } from '../../api/variants'
;(($) => {
    $(() => {
        const module = $('.new-product-view.slings')
        window.initSwiperGallery()
        // Only continue if on product view slings page
        if (!module.length) return

        const params = new URL(document.location.toString()).searchParams;
        const paramVariantId = params.get("variantId"); 
        const productUrlCopyLink = $('#product_url_copy_link');
        productUrlCopyLink.click(() => copyLinkToClipboard());

        const slingsForm = $('#slings-form')
        const slingsFormLoader = $('.slings-form-loader')
        const showAllVariantsLink = $('.npp__show-all-variants')
        const showContactUsTab = $('.npp__show-contact-us')
        const showMoreButton = $('.show-more__button')
        const increaseButton = $('.button-increase')
        const decreaseButton = $('.button-decrease')
        const quantityInput = $('.input-quantity')
        const priceDiv = $('.npp__price')
        const batchPriceDiv = $('.npp__batch-price')
        const fullPackageOption = $('.npp__price-option--package')
        const singlePriceRadio = $('.npp__price-option--single .npp__price-radio')
        const excludeVatBatch = $('.exclude-vat-batch')
        const stockDiv = $('.npp__stock--info')
        const partCodeDiv = $('.npp__title--heading2')
        const stockModal = $('#stockModal')
        const data = JSON.parse(slingsForm.attr('data-variants'))
        const variantsTab = document.querySelector('#variants')
        const contactUsTab = document.querySelector('#contact-us')
        const productInformationTab = document.querySelector('#product-information')
        let variants = data.variants
        const options = data.options
        let cartWidgetAttributes = data.options.cartWidgetAttributes
        let selectedVariant
        const excludeVat = $('.exclude-vat');
        const slingsSubmitButton = $('.slings-submit-button')
        const rentalSubmitButton = $('#rental-submit-button')
        let isRentalClick = false;
        const allowDecimalQty =
            $('.new-product-card').data('allow-decimal') === 1 ||
            $('.new-product-card').data('allow-decimal') === true;
       
        showMoreButton.click(() => goToAndOpenTab(productInformationTab))
        showAllVariantsLink.click(() => goToAndOpenTab(variantsTab))
        showContactUsTab.click(() => goToAndOpenTab(contactUsTab))

        if (variants.length == 0)
            document.querySelector('.variant-media-spinner .quick-order-spinner').style.display = 'none';

        const goToAndOpenTab = (target) => {
            if (target) {
                target.click()
                scrollTo(target, -160)
            }
        }

        slingsSubmitButton.on('click', function () {
            isRentalClick = $(this).attr('data-buttonType');
        });
        
        rentalSubmitButton.on('click', function () {
            isRentalClick = $(this).attr('data-buttonType');
        });

        let setQty = allowDecimalQty ? 1.0 : 1;
        const STEP = 0.1;
        /**
         * Parse quantity safely
         * - Replace comma with dot
         * - Remove invalid chars
         */
        const parseQty = (val) => {
            if (typeof val !== 'string') val = String(val);
            return parseFloat(val.replace(',', '.'));
        };

        /**
         * Allow only numbers, dot and comma while typing
         */
        quantityInput.on('input', function () {
            let value = this.value.replace(/[^0-9.,]/g, '');

            // allow only ONE decimal separator
            const firstSep = value.search(/[.,]/);
            if (firstSep !== -1) {
                const before = value.slice(0, firstSep + 1);
                const after = value.slice(firstSep + 1).replace(/[.,]/g, '');
                value = before + after;
            }

            this.value = value;
        });


        /**
         * Validate on change / blur
         */
        quantityInput.on('change blur', (e) => {
            const rawValue = e.currentTarget.value.trim();
            const qty = parseQty(rawValue);

            // Invalid → reset
            if (!rawValue || isNaN(qty) || qty <= 0) {
                quantityInput.val(String(setQty));
                refreshPrice();
                return;
            }

            // Decimals not allowed → force integer
            if (!allowDecimalQty) {
                quantityInput.val(String(Math.floor(qty)));
            }
            // Decimals allowed → KEEP user format (5.2 or 5,2)

            refreshPrice();
        });

        increaseButton.on('click', (e) => {
            incrementQuantity(e)
            refreshPrice()
        })

        decreaseButton.on('click', (e) => {
            decrementQuantity(e)
            refreshPrice()
        })

        slingsForm.on('submit', (e) => {
            e.preventDefault()
            if (options.showAddToCart) {
                sendGeneric(slingsForm)
            } else {
                sendQuote()
            }
        })

        $(document).on('change', 'input[name="price_option"]', function () {
            const radioVal = $(this).val()
            const packQty = parseInt($('input[name="price_option"][value="package"]').data('pack-qty'), 10)

            if (radioVal === 'package' && packQty > 0) {
                quantityInput.val(allowDecimalQty ? `${packQty}.0` : String(packQty))
            } else {
                quantityInput.val(allowDecimalQty ? '1.0' : '1')
            }
            refreshPrice()
        })

        /**
         * Get current quantity
         */
        const getQuantity = () => {
            return parseQty(quantityInput.val());
        };

        const isPackageSelected = () =>
            $('input[name="price_option"][value="package"]').is(':checked')

        const getPackStep = () => {
            if (!isPackageSelected()) return null
            const qty = parseInt($('input[name="price_option"][value="package"]').data('pack-qty'), 10)
            return qty > 0 ? qty : null
        }

        /**
         * Increment
         */
        const incrementQuantity = (e) => {
            e.preventDefault();
            let currentQuantity = getQuantity();
            const packStep = getPackStep();

            if (packStep) {
                const next = !isNaN(currentQuantity) ? currentQuantity + packStep : packStep;
                quantityInput.val(allowDecimalQty ? formatQtyLikeInput(next) : next);
            } else if (allowDecimalQty) {
                const next = !isNaN(currentQuantity) ? currentQuantity + STEP : STEP;
                quantityInput.val(formatQtyLikeInput(next));
            } else {
                quantityInput.val(!isNaN(currentQuantity) ? currentQuantity + 1 : 1);
            }

            refreshPrice();
        };

        const formatQtyLikeInput = (value) => {
            const hasComma = quantityInput.val().includes(',');
            return hasComma
                ? value.toFixed(1).replace('.', ',')
                : value.toFixed(1);
        };


        /**
         * Decrement
         */
        const decrementQuantity = (e) => {
            e.preventDefault();
            let currentQuantity = getQuantity();
            const packStep = getPackStep();

            if (packStep) {
                const next = !isNaN(currentQuantity) && currentQuantity > packStep
                    ? currentQuantity - packStep
                    : packStep;
                quantityInput.val(allowDecimalQty ? formatQtyLikeInput(next) : next);
                refreshPrice();
                return;
            }

            if (allowDecimalQty) {
                const next =
                    !isNaN(currentQuantity) && currentQuantity > STEP
                        ? currentQuantity - STEP
                        : STEP;
                quantityInput.val(formatQtyLikeInput(next));
            } else {
                quantityInput.val(
                    !isNaN(currentQuantity) && currentQuantity > 1
                        ? currentQuantity - 1
                        : 1
                );
            }

            refreshPrice();
        };
        const getLocaleCode = () => $('html').attr('data-locale').replace('_', '-')

        const getPriceFormatted = (price) => {
            return new Intl.NumberFormat(getLocaleCode(), {
                style: 'currency',
                currency: selectedVariant.currencyCode,
            }).format(price)
        }

        const getIndexByKeys = (obj, primaryKey, secondaryKey) => {
            let idx = obj.findIndex((variant) => variant[primaryKey] && variant[secondaryKey])
            if (idx === -1) {
                idx = obj.findIndex((variant) => variant[primaryKey])
            }
            if (idx === -1) {
                idx = obj.findIndex((variant) => variant[secondaryKey] > 0)
            }
            if (idx === -1) {
                idx = 0
            }
            return idx
        }

        const setFirstAvailableVariant = (variants) => {
            let firstAvailableVariantIdx = getIndexByKeys(variants, 'Price', 'Stock')
            if (firstAvailableVariantIdx !== -1 && firstAvailableVariantIdx < variants.length) {
                variants[firstAvailableVariantIdx].selected = true
            } else {
                console.error('No valid variant found to set as selected')
            }
            return variants
        }

        const checkVariantsData = (variants, cartWidgetAttributes) => {
            cartWidgetAttributes.forEach((attribute) => {
                variants.map((variant) => {
                    if (!variant[attribute]) {
                        variant[attribute] = `${window.globals.trans('product-page.not-specified')}`;
                    }
                });
            });
        
            return variants;
        };

        const updateVariantsObject = (newData) => {
            variants.find((variant) => {
                if (variant === selectedVariant) {
                    Object.keys(newData).forEach((item) => {
                        variant[item] = newData[item]
                    })
                }
            })
        }

        const shouldDisplayDualPrices = (normalPrice, discountPrice) => {
            return (
                options.isCustomerUniquePriceActive &&
                options.displayDualPrices &&
                discountPrice !== undefined &&
                discountPrice !== '-' &&
                normalPrice !== String(discountPrice)
            )
        }

        const displayDualPrices = (normalPrice, discountPrice) => {
            const normalPriceElement = $('<span></span>')
                .addClass('price-text line-through')
                .css('opacity', '0.5')
                .css('margin-right', '10px')
                .html(getPriceFormatted(normalPrice))

            const discountPriceElement = $('<span></span>').addClass('fresh-price-text').html(getPriceFormatted(discountPrice))

            priceDiv.append(normalPriceElement)
            priceDiv.append(discountPriceElement)
        }

        const displayPrice = async (normalPrice) => {
            let priceToDisplay

            if (options.isCustomerUniquePriceActive) {
                try {
                    if (options.erpPrice) {
                        priceToDisplay = await fetchUniquePrice()
                    } else {
                        priceToDisplay = await fetchDiscountPrice()
                    }
                } catch (error) {
                    console.error('Error fetching price:', error)
                    priceToDisplay = normalPrice
                }
            }

            if (!priceToDisplay) {
                priceToDisplay = normalPrice
            }

            priceDiv.empty()

            if (normalPrice !== null) {
                if (shouldDisplayDualPrices(normalPrice, priceToDisplay)) {
                    displayDualPrices(normalPrice, priceToDisplay)
                } else {
                    displaySinglePrice(priceToDisplay === '-' ? normalPrice : priceToDisplay)
                }
            } else {
                priceDiv.empty()
            }
        }

        const displaySinglePrice = (priceToDisplay) => {
            if (priceToDisplay !== undefined) {
                const quantity = getQuantity();
                const price = Number(priceToDisplay);
                const total = Math.ceil(quantity * price * 100) / 100;

                priceDiv.html(getPriceFormatted(total));
                excludeVat.css('display', !isNaN(price) && price > 0 ? 'inline-block' : '')
            } else {
                priceDiv.empty()
            }
        }

        const showPackageOptions = () => {
            singlePriceRadio.show()
            if (fullPackageOption[0]) fullPackageOption[0].style.removeProperty('display')
        }

        const hidePackageOptions = () => {
            singlePriceRadio.hide()
            if (fullPackageOption[0]) fullPackageOption[0].style.setProperty('display', 'none', 'important')
            $('input[name="price_option"][value="single"]').prop('checked', true)
        }

        const displayBatchPrice = (variant) => {
            const packQty = parseInt($('input[name="price_option"][value="package"]').data('pack-qty'), 10)
            const unitPrice = Number(variant.Price)

            if (packQty > 1 && unitPrice) {
                const quantity = getQuantity()

                if (isPackageSelected()) {
                    // Case 2 — package: npp__price = per-piece (×1), npp__batch-price = price × qty
                    priceDiv.html(getPriceFormatted(unitPrice))
                    batchPriceDiv.html(getPriceFormatted(Math.ceil(quantity * unitPrice * 100) / 100))
                } else {
                    // Case 1 — single: npp__price = price × qty, npp__batch-price = price × packQty
                    priceDiv.html(getPriceFormatted(Math.ceil(quantity * unitPrice * 100) / 100))
                    batchPriceDiv.html(getPriceFormatted(Math.ceil(packQty * unitPrice * 100) / 100))
                }

                excludeVat.css('display', 'inline-block')
                excludeVatBatch.css('display', 'inline-block')
                showPackageOptions()
            } else {
                hidePackageOptions()
                priceDiv.html(variant.BatchPriceFormattedWithPacking ?? variant.PriceFormatted ?? '')
                excludeVat.css('display', '')
            }
        }

        const fetchUniquePrice = () => {
            return new Promise((resolve, reject) => {
                slingsFormLoader.show()
                priceDiv.append('<div class="loader"></div>')
                getFreshPrice(selectedVariant.PartCode)
                    .then((res) => {
                        const freshPriceData = res.data
                        updateVariantsObject(freshPriceData)
                        resolve(freshPriceData.Price)
                    })
                    .catch((err) => {
                        console.error(err)
                        reject(err)
                    })
                    .finally(() => {
                        slingsFormLoader.hide()
                        selectedVariant.priceRefreshed = true
                        priceDiv.find('.loader').remove()
                    })
            })
        }

        const fetchDiscountPrice = () => {
            return new Promise((resolve, reject) => {
                slingsFormLoader.show()
                priceDiv.append('<div class="loader"></div>')
                getDiscountProductPrice(selectedVariant.id)
                    .then((res) => {
                        const freshPriceData = res.data
                        updateVariantsObject(freshPriceData)
                        resolve(freshPriceData.Price)
                    })
                    .catch((err) => {
                        console.error(err)
                        reject(err)
                    })
                    .finally(() => {
                        slingsFormLoader.hide()
                        selectedVariant.priceRefreshed = true
                        priceDiv.find('.loader').remove()
                    })
            })
        }

        const refreshPrice = async () => {
        
            if (!selectedVariant) {
                console.error('Selected variant is undefined')
                return
            }

            const packQty = parseInt($('input[name="price_option"][value="package"]').data('pack-qty'), 10)
            if (selectedVariant.isBatchPrice || packQty > 0) {
                await displayBatchPrice(selectedVariant)
                return
            }

            hidePackageOptions()
            excludeVat.css('display', '')
            await displayPrice(selectedVariant.Price)
        }
        
        const getStockLevel = () => {
            if (!selectedVariant) {
                console.error('Selected variant is undefined')
                return 0
            }
            return parseInt(selectedVariant.Stock)
        }
        
        const getAvailabilityLabel = (stockLevel, showUnits = false) => {
            let stockText = stockLevel > 0 ? `${window.globals.trans('filter.in_stock')}` : `${window.globals.trans('filter.out_of_stock')}`
            if (showUnits && stockLevel > 0) {
                stockText += ` (${stockLevel} ${window.globals.trans('units')})`
            }
            return stockText
        }
        const getAvailabilityIndicatorClass = (stockLevel) => (stockLevel > 0 ? 'stock in' : 'stock out')

        const generateStockInfo = (stockLevel) =>
            `<span class="stock-text">${getAvailabilityLabel(stockLevel)}</span> <span class="${getAvailabilityIndicatorClass(stockLevel)}"></span>`
        const generateStockWarehouseInfo = (stockLevel) =>
            `<span class="${getAvailabilityIndicatorClass(stockLevel)}"></span> <span class="stock-text">${getAvailabilityLabel(stockLevel, true)}</span>`

        const refreshStock = () => {
            const stockLevel = getStockLevel()

            if (!isNaN(stockLevel)) {
                stockDiv.html(generateStockInfo(stockLevel))
            } else {
                stockDiv.html(
                    `<span class="stock-text"><a href="${slingsForm.attr('data-contact-url')}" class="ask" target="_blank">${window.globals.trans(
                        'filter.ask',
                    )}</a></span> <span class="stock no"></span>`,
                )
            }
        }
        const generateWarehousesTable = (warehouses) => {
            const tableBody = document.querySelector('#warehousesTable tbody')

            if (warehouses && warehouses.length > 0) {
                const populateTable = (warehouses) => {
                    tableBody.innerHTML = warehouses
                        .map(
                            ({ name, stock }) => `
                <tr>
                    <td class="stock-modal__name">${name}</td>
                    <td class="stock-modal__stock">${generateStockWarehouseInfo(stock)}</td>
                </tr>
            `,
                        )
                        .join('')
                }
                populateTable(warehouses)
            } else {
                tableBody.innerHTML = `<tr><td colspan="2" class="text-center font-italic">${window.globals.trans(
                    'product-page.no-warehouses-message',
                )}</td></tr>`
            }
        }

        const refreshStockModalData = () => {
            if (!selectedVariant) return
            const partCode = selectedVariant.PartCode
            const warehouses = selectedVariant.warehouses
            stockModal.find('.stock-modal__partcode').html(`<span class="bold">${window.globals.trans('product-page.product-number')}</span>: ${partCode}`)
            generateWarehousesTable(warehouses)
        }

        const refreshPartCode = () => {
            if (!selectedVariant) return
            const partCode = selectedVariant.PartCode
            partCodeDiv.text(partCode)
        }

        const generateDropdowns = (data) => {
            // Create a mapping of keys to labels
            const columnsMap = data.columns.reduce((map, column) => {
                map[column.key] = column.label;
                return map;
            }, {});

            // Find the placeholder element
            const placeholder = document.querySelector('.npp__slings-form .form-group');
            const referenceNode = placeholder.lastElementChild;

            // Generate select elements for each attribute in cartWidgetAttributes
            cartWidgetAttributes.forEach((attr) => {
                const formItemDiv = document.createElement('div');
                formItemDiv.className = 'form-item';

                const label = columnsMap[attr];
                const select = document.createElement('select');
                select.id = `select-${attr}`;
                select.className = 'form-control';

                const labelElement = document.createElement('label');
                labelElement.innerHTML = label;
                labelElement.setAttribute('for', select.id);

                formItemDiv.appendChild(labelElement);
                formItemDiv.appendChild(select);
                placeholder.insertBefore(formItemDiv, referenceNode);

                /* Fix for LISXGPIM-312 */
                document.querySelectorAll('.custom_br_Remove br').forEach((br) => {
                    const span = document.createElement('span');
                    span.className = 'line-break';
                    span.innerHTML = ' ';
                    br.replaceWith(span);
                  });
            });

            // Initialize selectric
            cartWidgetAttributes.forEach(attr => {
                $(`#select-${attr}`).selectric({
                    disableOnMobile: false,     // Do not disable on mobile
                    nativeOnMobile: false,      // Force custom UI instead of native
                    onChange: () => {
                        updateNextSelects(cartWidgetAttributes.indexOf(attr));
                        setSelectedVariant();
                        refreshPrice();
                        refreshStock();
                        refreshPartCode();
                        refreshStockModalData();
                    }
                });
            });

            // Populate the first select element
            const firstAttr = cartWidgetAttributes[0];
            const firstSelect = document.getElementById(`select-${firstAttr}`);
            const uniqueValues = [...new Set(data.variants.map(variant => variant[firstAttr]))];

            uniqueValues.forEach((value, index) => {
                const option = document.createElement('option');
                option.value = value;
                option.text = value;
                if (paramVariantId) {
                    const selectedVariantObj = variants.find(product => product.id == paramVariantId);
                    if (selectedVariantObj) {
                        const firstAttrSelect = selectedVariantObj[firstAttr];
                        if (value == firstAttrSelect) {
                            option.selected = true;
                        }
                    } else {
                        if (index === 0) {
                            option.selected = true;
                        }
                    }
                } else {
                    const selectedVariantObj = variants.find(product => product.selected == true);
                    if (selectedVariantObj) {
                        const firstAttrSelect = selectedVariantObj[firstAttr];
                        if (value == firstAttrSelect) {
                            option.selected = true;
                        }
                    } else {
                        if (index === 0) {
                            option.selected = true;
                        }
                    }
                }
                firstSelect.appendChild(option);
            });

            // Initialize selectric for the first select
            $(`#select-${firstAttr}`).selectric();

            // Function to update the next select elements based on the previous select's value
            const updateNextSelects = (currentIndex) => {
                for (let i = currentIndex + 1; i < cartWidgetAttributes.length; i++) {
                    const currentAttr = cartWidgetAttributes[i - 1];
                    const nextAttr = cartWidgetAttributes[i];
                    const currentSelect = document.getElementById(`select-${currentAttr}`);
                    const nextSelect = document.getElementById(`select-${nextAttr}`);
                    const selectedValue = currentSelect.value;
                    let filteredVariants = data.variants.filter(variant => variant[currentAttr] == selectedValue);

                    // Filter variants based on all previous selects
                    for (let j = 0; j < i - 1; j++) {
                        const prevAttr = cartWidgetAttributes[j];
                        const prevSelect = document.getElementById(`select-${prevAttr}`);
                        const prevSelectedValue = prevSelect.value;
                        filteredVariants = filteredVariants.filter(variant => variant[prevAttr] == prevSelectedValue);
                    }

                    const uniqueNextValues = [...new Set(filteredVariants.map(variant => variant[nextAttr]))];

                    // Clear previous options
                    nextSelect.innerHTML = '';

                    uniqueNextValues.forEach((value, index) => {
                        const option = document.createElement('option');
                        option.value = value;
                        option.text = value;

                        if (paramVariantId) {
                            const selectedVariantObj = variants.find(product => product.id == paramVariantId);
                            if (selectedVariantObj) {
                                const nextAttrSelect = selectedVariantObj[nextAttr];
                                if (value == nextAttrSelect) {
                                    option.selected = true;
                                }
                            } else {
                                if (index === 0) {
                                    option.selected = true;
                                }
                            }
                        } else {
                            const selectedVariantObj = variants.find(product => product.selected == true);
                            if (selectedVariantObj) {
                                const nextAttrSelect = selectedVariantObj[nextAttr];
                                if (value == nextAttrSelect) {
                                    option.selected = true;
                                }
                            } else {
                                if (index === 0) {
                                    option.selected = true;
                                }
                            }
                        }
                        nextSelect.appendChild(option);
                    });

                    // Initialize selectric for the next select
                    $(`#select-${nextAttr}`).selectric('refresh');
                }
            };

            // Function to set the selected variant based on the current select values
            const setSelectedVariant = () => {
                const found = data.variants.find(variant => {
                    return cartWidgetAttributes.every(attr => {
                        const select = document.getElementById(`select-${attr}`);
                        return variant[attr] == select.value;
                    });
                });

                if (!found) return;
                selectedVariant = found;

                quantityInput.val(allowDecimalQty ? '1.0' : '1')

                // Sync package radio data and label text from the selected variant's PackQty
                const variantPackQty = parseInt(selectedVariant.PackQty, 10) || 0
                $('input[name="price_option"][value="package"]')
                    .data('pack-qty', variantPackQty)
                    .attr('data-pack-qty', variantPackQty)
                $('.npp__pack-qty-label').text(variantPackQty)

                // If package radio is already selected, update the quantity input to match new variant's PackQty
                if (isPackageSelected() && variantPackQty > 0) {
                    quantityInput.val(allowDecimalQty ? `${variantPackQty}.0` : String(variantPackQty))
                }

                if (selectedVariant.id) {
                    let url = window.location.href;

                    // Check if the URL has a '#' at the end and remove it
                    if (url.endsWith('#')) {
                        url = url.slice(0, -1);
                    }

                    if (url.indexOf('?') !== -1) {
                        if (url.indexOf('variantId=') !== -1) {
                            url = url.replace(/(variantId=)([^&]*)/, '$1' + selectedVariant.id);
                        } else {
                            url += '&variantId=' + selectedVariant.id;
                        }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
                    } else {
                        url += '?variantId=' + selectedVariant.id;
                    }

                    $("#product_url_copy_link").attr("data-url", url)

                    // Call method to load and render images
                    updateProductImages(selectedVariant.id);
                }
            };

            // Initial population of the second select and beyond
            updateNextSelects(0);

            // Set the initial selected variant and refresh data
            setSelectedVariant();
            refreshPrice();
            refreshStock();
            refreshPartCode();
            refreshStockModalData();
        };

        const init = () => {
            variants = setFirstAvailableVariant(variants)
            variants = checkVariantsData(variants, cartWidgetAttributes)
            generateDropdowns(data);
            refreshPrice()
            refreshStock()
            refreshPartCode()
            refreshStockModalData()
            initVariantsTableSearch()
            initVariantsTableToggle()
        }

        const postData = (data) => {
            axios({
                method: 'post',
                url: slingsForm.attr('data-action-url'),
                data: data,
            })
                .then((response) => {
                    const data = response.data
                    CartManager.updateCoreshopCartCount(data)
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'add_to_cart',
                            ecommerce: {
                                currency: data.currencyCode || '',
                                items: [
                                    {
                                      item_id: data.id.toString(),
                                      item_name: data.name,
                                      price: data.price || '0',
                                      quantity: parseInt(data.qty, 10),
                                      item_category: data.category || ''
                                    }
                                ]
                            },
                        })
                    }
                })
                .catch((err) => {
                    throw err
                })
        }

        const sendGeneric = () => {
            const data = {
                quantity: getQuantity().toString(),
                product: selectedVariant.id.toString(),
                IsRentalBtn: isRentalClick,
            }
            postData(data)
        }

        const sendQuote = () => {
            const quantity = getQuantity().toString()
            const variantId = selectedVariant.id.toString()
            CartManager.addToCart(variantId, quantity, isRentalClick)
        }

        const copyLinkToClipboard = () => {
            return new Promise((resolve, reject) => {
                try {
                    var urlToCopy = $('#product_url_copy_link').attr('data-url');
                    var $tempInput = $('<input>');
                    $('body').append($tempInput);
                    $tempInput.val(urlToCopy).select();
                    document.execCommand('copy');
                    $tempInput.remove();
                    $('#copy-message').fadeIn().delay(2000).fadeOut();
                    resolve('URL copied successfully');
                } catch (error) {
                    console.error('Failed to copy URL:', error);
                    reject('Failed to copy URL');
                }
            });
        };

        const updateProductImages = (variantId) => {
            const locale = document.documentElement.getAttribute('data-locale') || 'en_GB';
            document.querySelector('.variant-media-spinner .quick-order-spinner').style.display = 'block';

            const swiperWrapper = document.querySelector('#variant-media');
        
            axios.get(`/variant-image/${variantId}`, {
                headers: {
                    'Accept': 'text/html'
                },
                params: {
                    locale: locale
                }
            })
            .then(response => {
                // Replace just the swiper-wrapper's contents
                swiperWrapper.innerHTML = response.data.productVariantImage;
                window.initSwiperGallery()

                if (response.data.isRental == true) {
                    const swiperMediaCarousel = document.getElementById('swiper-media-carousel')
                    const rentalImageTag = document.createElement('span')
                    rentalImageTag.classList.add('rental-image-tag')
                    const rentalImage = document.createElement('img')
                    rentalImage.setAttribute('src', document.getElementById('rentalIcon').value)
                    rentalImage.setAttribute('alt', document.getElementById('rentalIconAltText').value);
                    rentalImageTag.appendChild(rentalImage)
                    swiperMediaCarousel.prepend(rentalImageTag)
                }

                document.querySelector('.variant-media-spinner .quick-order-spinner').style.display = 'none';
            })
            .catch(err => {
                console.error('Error loading product images:', err);
                swiperWrapper.innerHTML = '<img loading="eager" src="/pim/fallback/Fallback picture.svg" width="400" height="400" alt="Failed to load images" title="Failed to load images">';
                document.querySelector('.variant-media-spinner .quick-order-spinner').style.display = 'none';
            });
        };

        // UOM toggle
        let currentUom = data.options.uomToggle?.current || null
        window.currentUom = currentUom

        const updatePdfLink = (uom) => {
            const pdfLink = document.querySelector('.download-pdf-document')
            if (!pdfLink || !uom) return
            try {
                const url = new URL(pdfLink.href)
                url.searchParams.set('uom', uom)
                pdfLink.href = url.toString()
            } catch (e) {}
        }
        updatePdfLink(currentUom)

        $(document).on('change', '.uom-toggle-checkbox', async function () {
            const uom = $(this).prop('checked') ? 'imperial' : 'metric'
            if (uom === currentUom) return
            const previousUom = currentUom
            currentUom = uom
            window.currentUom = uom
            updatePdfLink(uom)
            $(this).prop('disabled', true)
            $('.npp__uom-toggle').addClass('loading')
            slingsFormLoader.show()
            try {
                const response = await getCartWidget(uom)
                const newData = response.data.data
                data.variants = newData.variants
                data.columns = newData.columns
                variants = newData.variants
                cartWidgetAttributes = newData.options.cartWidgetAttributes
                variants = setFirstAvailableVariant(variants)
                variants = checkVariantsData(variants, cartWidgetAttributes)
                data.variants = variants
                const placeholder = document.querySelector('.npp__slings-form .form-group')
                if (placeholder) {
                    placeholder.querySelectorAll('.form-item').forEach(el => {
                        if (el.querySelector('select[id^="select-"]')) el.remove()
                    })
                }
                generateDropdowns(data)
                $(document).trigger('uomToggle')
                if (document.getElementById('filters')) {
                    await new Promise(resolve => $(document).one('uomToggleComplete', resolve))
                }
            } catch (e) {
                // Revert state so the user can retry the toggle
                currentUom = previousUom
                window.currentUom = previousUom
                updatePdfLink(previousUom)
                $(this).prop('checked', previousUom === 'imperial')
                console.error('UOM toggle failed', e)
            } finally {
                $(this).prop('disabled', false)
                $('.npp__uom-toggle').removeClass('loading')
                slingsFormLoader.hide()
            }
        })

        if (variants.length > 0) init()
    })
})(jQuery)
